import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { confirmUserAccount } from "../../services/user/api";
import { toast } from "react-toastify";

function readTokenFromUrl() {
  const href = window.location.href;

  try {
    const normal = new URL(href).searchParams.get("token");
    if (normal) return normal;
  } catch (e) {}
  const hash = href.split("#")[1] || "";
  const query = hash.split("?")[1] || "";

  return new URLSearchParams(query).get("token");
}

const ConfirmAccount = () => {
  const navigate = useNavigate();
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    const token = readTokenFromUrl();
    if (!token) {
      alert("No token found in URL");
      navigate("/")
      return;
    }

    const encodedToken = encodeURIComponent(token);

    confirmUserAccount(encodedToken)
      .then((response) => {
        toast.success(response?.data?.message || "Account confirmed successfully!");
        navigate("/");
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || error.message || "Verification failed");
        navigate("/");
      });
  }, [navigate]);

  return <div>Confirming your account...</div>;
};

export default ConfirmAccount;